<template>
  <v-row no-gutters justify="center">
    <div class="progress">
      <div class="pb-2">{{ fileName }}</div>
      <v-progress-linear
        :value="progress"
        :indeterminate="uploadIsStarting"
      />
    </div>
    <v-btn
      fab
      x-small
      elevation="0"
      class="mx-2"
      color="#e1e9ff"
      @click="$emit('cancel')"
    >
      <v-icon class="close-icon">close</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  name: 'UploadProgressBar',
  props: {
    fileName: {
      type: String,
      required: true,
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    uploadIsStarting() {
      return this.progress === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress {
  min-width: 350px;
}
.progress > div {
  max-width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.close-icon {
  color: #aabef9 !important;
}
</style>
